import { trueFalseToYesNo, formatNumber, stringNotNullOrEmptyYesNo } from '@/util/formatters'
let repairsCols = [
    {
        key: 'displayLabel',
        display: 'Gadget'
    },
    {
        key: 'repairOptionTypeLabel',
        display: 'Option Type'
    },
    {
        key: 'repairProviderLabel',
        display: 'Provider'
    },
    {
        key: 'authorisationId',
        display: 'Auth ID'
    },
    {
        key: 'supplierImportRROptionStatusLabel',
        display: 'Status'
    },
    {
        key: 'estimatedCost',
        display: 'Estimate',
        customFormatter: formatNumber(2)
    },
    {
        key: 'quotedCost',
        display: 'Quote',
        customFormatter: formatNumber(2)
    },
    {
        key: 'quote',
        display: 'Quote only',
        customFormatter: trueFalseToYesNo
    },
    {
        key: 'ber',
        display: 'BER',
        customFormatter: trueFalseToYesNo
    },
    {
        key: 'faulty',
        display: 'Faulty',
        customFormatter: trueFalseToYesNo
    },
    {
        key: 'noteDetail',
        display: 'Note',
        customFormatter: stringNotNullOrEmptyYesNo
    },
    {
        key: 'userAccountActive',
        display: 'Account Active',
        customFormatter: trueFalseToYesNo
    },
    {
        key: 'dateCreatedAsLocalTime',
        display: 'Selected'
    },
    {
        key: 'dateCancelledAsLocalTime',
        display: 'Cancelled'
    },
    {
        key: 'emailAddress',
        display: 'Cancelled By'
    }
]

export { repairsCols }